// Minimal CSV helpers (Excel-compatible, UTF-8 BOM, ; or , delimiter aware).

export function toCSV(cols, data) {
  const esc = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = cols.map((c) => esc(c[1])).join(",");
  const lines = (data || []).map((row) => cols.map((c) => esc(row[c[0]])).join(","));
  return "\uFEFF" + [header, ...lines].join("\r\n");
}

export function downloadCSV(csv, filename) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function splitCSV(text) {
  const nl = text.indexOf("\n");
  const firstLine = nl >= 0 ? text.slice(0, nl) : text;
  const delim = firstLine.split(";").length > firstLine.split(",").length ? ";" : ",";
  const rows = [];
  let cur = [], field = "", inQ = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQ) {
      if (ch === '"') {
        if (text[i + 1] === '"') { field += '"'; i++; }
        else inQ = false;
      } else field += ch;
    } else if (ch === '"') {
      inQ = true;
    } else if (ch === delim) {
      cur.push(field); field = "";
    } else if (ch === "\n") {
      cur.push(field); rows.push(cur); cur = []; field = "";
    } else if (ch !== "\r") {
      field += ch;
    }
  }
  if (field.length > 0 || cur.length > 0) { cur.push(field); rows.push(cur); }
  return rows;
}

export function parseCSV(text, cols) {
  text = (text || "").replace(/^\uFEFF/, "");
  const rows = splitCSV(text);
  if (rows.length < 2) return [];
  const labelToField = {};
  cols.forEach(([field, label]) => {
    labelToField[label.trim().toLowerCase()] = field;
    labelToField[field.toLowerCase()] = field;
  });
  const idx = rows[0].map((h) => labelToField[(h || "").trim().toLowerCase()] || null);
  const out = [];
  for (let i = 1; i < rows.length; i++) {
    const cells = rows[i];
    if (cells.every((c) => (c || "").trim() === "")) continue;
    const obj = {};
    idx.forEach((field, j) => { if (field) obj[field] = (cells[j] || "").trim(); });
    out.push(obj);
  }
  return out;
}
